import { YoutubeLogo } from '@phosphor-icons/react';
import { replace } from 'out-of-character';

import { createEmbedProvider } from '../factory';

export const YOUTUBE_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\/|[?&].*)?$/i;

const parseTimestamp = (t: string): number | null => {
  const match = t.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/i);
  if (match) {
    const hours = parseInt(match[1] || '0', 10);
    const minutes = parseInt(match[2] || '0', 10);
    const seconds = parseInt(match[3] || '0', 10);
    const total = hours * 3600 + minutes * 60 + seconds;

    return total > 0 ? total : null;
  }

  return null;
};

const extractTimestamp = (href: string): number | null => {
  try {
    const normalizedHref = /^https?:\/\//i.test(href) ? href : `https://${href}`;
    const url = new URL(normalizedHref);
    const t = url.searchParams.get('t');
    if (!t) return null;

    return parseTimestamp(t);
  } catch {
    return null;
  }
};

export const youtubeProvider = createEmbedProvider({
  id: 'youtube',
  label: 'YouTube Video',
  icon: <YoutubeLogo size={20} weight="fill" className="text-red-500" />,
  regex: YOUTUBE_URL_REGEX,
  buildEmbedUrl: (match, cleanedUrl) => {
    const videoId = match[1];
    const timestamp = extractTimestamp(cleanedUrl);

    return `https://www.youtube-nocookie.com/embed/${videoId}?modestbranding=1${
      timestamp ? `&start=${timestamp}` : ''
    }`;
  },
  buildTitle: (url) => {
    const cleanHref = replace(url);
    const match = cleanHref.match(YOUTUBE_URL_REGEX);
    const videoId = match?.[1];

    return `YouTube Embed${videoId ? ` (${videoId})` : ''}`;
  },
});
